var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.fetchedError)?[_vm._v("sprawdź cenę w sklepie")]:[(_vm.fetchedPrice[_vm.productCode])?[_vm._v(" "+_vm._s(_vm.prefix)+_vm._s(_vm._f("priceFormat")(_vm.fetchedPrice[_vm.productCode]))+" zł ")]:(_vm.productCode === 'none')?[_vm._v("bezpłatnie")]:[_vm._v("sprawdź cenę w sklepie")]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }